/**
 * External Dependencies
 */
import 'jquery';
import ScrollMagic from 'scrollmagic';
import barba from '@barba/core';

import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

function navigation() {
	$('body').removeClass('is-active');
	$.fn.extend({
    	toggleText: function(a, b){
        	return this.text(this.text() == b ? a : b);
	    }
	});

  	$('.hamburger').on('click', function(e){
		e.preventDefault();
		$('.hamburger, .overlay-menu, body').toggleClass('is-active');
		$('.hamburger .tag').toggleText('Close', 'Menu');
	});

  	$('.menu .menu-item-has-children a').click(function () {
	    var current = $(this).siblings('ul');

	    if ($('.nested').not(current).hasClass('active')) {
	      $('.nested.active').toggleClass('active');
	    }
	    $(this).siblings('ul').toggleClass('active');
	});
}

function utilities() {
	$('a[href*="#"]:not([href="#"])').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		  var target = $(this.hash);
		  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		  if (target.length) {
		    $('html, body').animate({
		      scrollTop: (target.offset().top - 200)
		    }, 1000);
		    return false;
		  }
		}
	});


	$(function() {
		var Accordion = function(el, multiple) {
			this.el = el || {};
			this.multiple = multiple || false;

			var links = this.el.find('.accordion-title');
			links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
		}

		Accordion.prototype.dropdown = function(e) {
			var $el = e.data.el;
			var $next = $(this).next();

			$next.slideToggle();
			$(this).parent().toggleClass('open');

			if (!e.data.multiple) {
				$el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
			};
		}

		var accordion = new Accordion($('#accordion'), false);
	});
}

function sliders() {
	//Swiper
	new Swiper('.standard-swiper', {
		loop: false,
		slidesPerView: 'auto',
        grabCursor: true,
		speed: 600,
        spaceBetween: 25,
        breakpoints: {
			640: {
				spaceBetween: 50,
			},
		},
		pagination: {
			el: '.standard-swiper .swiper-pagination',
        	type: 'fraction',
	  	},
		navigation: {
			nextEl: '.nav .next',
			prevEl: '.nav .prev',
		},
	});

	//Swiper
	new Swiper('.card-swiper', {
		loop: true,
		speed: 600,
		autoplay: {
		    delay: 3000,
		    disableOnInteraction: false,
		},
		slidesPerView: 1,
		spaceBetween: 15,
		slidesPerView: 'auto',
		breakpoints: {
			480: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			640: {
				slidesPerView: 3,
				spaceBetween: 25,
			},
			1000: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		},
	});

	new Swiper('.card-swiper-2', {
		loop: true,
		speed: 600,
		autoplay: {
		    delay: 4000,
		    disableOnInteraction: false,
		    reverseDirection: true,
		},
		slidesPerView: 1,
		spaceBetween: 15,
		slidesPerView: 'auto',
		breakpoints: {
			480: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			640: {
				slidesPerView: 3,
				spaceBetween: 25,
			},
			1000: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		},
	});
}

function fades() {
	var controller = new ScrollMagic.Controller();

	$('[data-animate="fade"]').each(function(){
		new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: 0.9, // show, when scrolled 10% into view
			offset: 50, // move trigger to center of element
			reverse: false
		}).setClassToggle(this, "visible")
		.addTo(controller);
	});

	// const asscroll = new ASScroll()

	// window.addEventListener('load', () => {
	//     asscroll.enable()
	// })

	// let scroll = new LocomotiveScroll({
	//   	el: document.querySelector('[data-scroll-container]'),
	// 	smooth: true,
	// 	multiplier: .5,
	// });
}

function siteFooter(content, el) {
	var siteContent = $(content);
	var siteContentHeight = siteContent.height();
	var siteContentWidth = siteContent.width();

	var siteFooter = $(el);
	var siteFooterHeight = siteFooter.height();
	var siteFooterWidth = siteFooter.width();

	siteContent.css({
		"margin-bottom" : siteFooterHeight + 50
	});
};

function animate() {
	barba.init({
		debug: true,
	    transitions: [{
	        name: 'default-transition',
	        afterLeave(data) {
				$('.page-transition h5').text(data.next.namespace);
				$('.page-transition').addClass('active');
				const done = this.async();
				setTimeout(function () {
					done();
				}, 1600);
				// return gsap.to(data.current.container, {
				//   opacity: 0
				// Account for loaded class added on window loaded
				// Set timeout to match entering animation duration
				setTimeout(function(){
					$('body').removeClass('loaded');
				}, 1200);
	        },
	        enter(data) {
				// return gsap.from(data.next.container, {
				//   opacity: 0
				// Account for loaded class added on window loaded
				// Set timeout to match entering animation duration
				$(window).scrollTop(0);
				setTimeout(function(){
					$('.page-transition').removeClass('active');
					$('.page-transition h5').text('');
				}, 1200);

				// Add loaded class, a fraction after fadeOut
				setTimeout(function(){
					$('body').addClass('loaded');
				}, 1400);
	        },
	    }],
    });

    barba.hooks.enter((data) => {
    	navigation();
		sliders();
		utilities();
  		siteFooter('main', 'footer');
  		siteFooter('footer', '.lower-footer');
		fades();

		var cf_selector = 'div.wpcf7 > form';
		var cf_forms = $(data.container).find(cf_selector);
		if (cf_forms.length>0) {
		  $(cf_selector).each(function() {
		      var $form = $(this);
		      wpcf7.initForm( $form );
		      if ( wpcf7.cached ) {
		          wpcf7.refill( $form );
		      }
		  });
		}
    });
}

$(document).ready(() => {
	navigation();
	sliders();
	utilities();
	fades();

	//add page transitions for desktop devices
	if(!$('body').hasClass('logged-in') && $(window).width() >= 640) {
	  	siteFooter('footer', '.lower-footer');
		animate();
	}
});

$(window).resize(function() {
  	siteFooter('footer', '.lower-footer');
});